import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { WalletCards, Settings } from 'lucide-react';
import { useProductSettings } from '@workspace/utils-react';
import type { Settings as AppSettings } from '../../../AppContainer';
import { checkBatchAdminAccess } from '../../../api/batch-admin';
import { Button } from '../../ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../ui/tooltip';
import { PageHeader } from '../../blocks/page-header';
import { NotificationBell } from '../../features/notification/NotificationBell';
import { isLocalDevelopment } from '../../../lib/environmentUtils';
import { useDevRole } from '../../../lib/devRoleOverride';
import { DevRoleSwitcher } from '../../dev/DevRoleSwitcher';

export function AppHeader() {
  const { apiUrl } = useProductSettings<AppSettings>();
  const [hasAccess, setHasAccess] = useState(false);
  const devRole = useDevRole();

  useEffect(() => {
    async function checkAccess() {
      try {
        const result = await checkBatchAdminAccess(apiUrl);
        setHasAccess(result.has_access);
      } catch {
        setHasAccess(false);
      }
    }
    checkAccess();
  }, [apiUrl, devRole]);

  return (
    <div className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 flex flex-row flex-nowrap content-center justify-between items-center w-[99%] mx-2.5 my-0 p-2.5">
          <PageHeader
            title="Financial Governance: Project Review & Approval"
            subtitle=""
            size={32}
            showActions={false}
            showBreadcrumb={false}
            useProductIcon={true}
            productIcon={<WalletCards className="h-9 w-9 text-primary" aria-hidden="true" />}
          />
          <div className="flex items-center gap-1">
            {isLocalDevelopment() && <DevRoleSwitcher />}
            <NotificationBell />
            {hasAccess && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Button variant="ghost" size="icon" asChild>
                      <Link to="/settings">
                        <Settings className="h-5 w-5" />
                      </Link>
                    </Button>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Settings</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
    </div>
  );
}
